export default "__VITE_ASSET__2fad1e46__"